
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/graduates/projects",
      function () {
        return require("private-next-pages/graduates/projects/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/graduates/projects"])
      });
    }
  